import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import "./parcoursEvolution.scss"
import BigButton from 'components/buttons/bigButton'
export default function ParcoursEvolution() {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Mon parcours d'évolution professionnelle",
            icon : "picto parcours evolution professionnelle - v2.svg",
            color : "bckRed"
        })
    }, [])
    return (
        <div id="parcoursEvolution"  className='page'>
            <ul>
                <li>
                    <div></div>
                    <p>Les dispositifs individuels de formation visent à permettre d’évoluer par
                        la promotion, de changer de métier ou de construire un nouveau projet
                        professionnel.
                    </p>
                </li>
                <br />
                <br />
                <br />
                <br />
                <br />
                <li>
                    <img className="bulle" src="/picto_bulle_interrogation.svg" alt="" />
                    <p>
                        <span>Se renseigner auprès de qui ? </span>
                        pour l’ensemble de ces dispositifs, un
                        rendez-vous préalable avec le Pôle formation continue et développement professionnel de la DRHF
                        est préconisé : poste 68 085
                    </p>
                </li>
                <div className='w100 flex center'>
                    <BigButton 
                        title="Trombinoscope" 
                        icon="picto_trombinoscope.svg" 
                        page={"/accueil/parcours_evolution/trombinoscope_parcours_pro"} 
                        background="bckRed80" 
                    />
                </div>
                <li>
                    <img className="bulle" src="/picto_bulle_interrogation.svg" alt="" />
                    <p>
                        <span>Pour quoi ? </span> 
                        Vous aider à faire le point, à changer
                        de métier, à créer une activité.
                    </p>
                </li>
                <li>
                    <img className="bulle" src="/picto_bulle_interrogation.svg" alt="" />
                    <p><span>Quels sont les différents dispositifs individuels ? </span></p>
                </li>
                <div className='w100 flex center'>
                    <BigButton
                        title="Les dispositifs individuels"
                        icon="picto_dispositifs_individuels.svg"
                        page={"/accueil/parcours_evolution/dispositifs_individuels"}
                        background="bckRed80" 
                    />
                </div>
            </ul>
        </div>
    )
}
